@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<app-navbar></app-navbar>

<div class="terms" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h1>{{ 'terms.title' | translate }}</h1>

    <h2>{{ 'terms.object.title' | translate }}</h2>
    <p>{{ 'terms.object.content' | translate }}</p>

    <h2>{{ 'terms.definitions.title' | translate }}</h2>
    <p class="bold-text">{{ 'terms.definitions.svet.title' | translate }}</p>
    <p>{{ 'terms.definitions.svet.content' | translate }}</p>
    <p class="bold-text">{{ 'terms.definitions.client.title' | translate }}</p>
    <p>{{ 'terms.definitions.client.content' | translate }}</p>
    <p class="bold-text">{{ 'terms.definitions.token.title' | translate }}</p>
    <p>{{ 'terms.definitions.token.content' | translate }}</p>
    <p class="bold-text">{{ 'terms.definitions.starter.title' | translate }}</p>
    <p>{{ 'terms.definitions.starter.content' | translate }}</p>
    <p class="bold-text">{{ 'terms.definitions.pro.title' | translate }}</p>
    <p>{{ 'terms.definitions.pro.content' | translate }}</p>
    <p class="bold-text">{{ 'terms.definitions.entreprise.title' | translate }}</p>
    <p>{{ 'terms.definitions.entreprise.content' | translate }}</p>

    <h2>{{ 'terms.service_description.title' | translate }}</h2>
    <p>{{ 'terms.service_description.content' | translate }}</p>

    <h2>{{ 'terms.prices.title' | translate }}</h2>
    <p> <span class="bold-text">{{ 'terms.prices.starter.title' | translate }}</span> : {{
        'terms.prices.starter.content' | translate }}</p>
    <p><span class="bold-text">{{ 'terms.prices.pro.title' | translate }}</span> : {{ 'terms.prices.pro.content' |
        translate }}</p>
    <p><span class="bold-text">{{ 'terms.prices.entreprise.title' | translate }}</span> : {{
        'terms.prices.entreprise.content' | translate }}</p>

    <h2>{{ 'terms.responsibility.title' | translate }}</h2>
    <p><span class="bold-text">{{ 'terms.responsibility.svet.title' | translate }}</span> : {{
        'terms.responsibility.svet.content' | translate }}</p>
    <p><span class="bold-text">{{ 'terms.responsibility.client.title' | translate }}</span> : {{
        'terms.responsibility.client.content' | translate }}</p>

    <h2>{{ 'terms.confidentiality.title' | translate }}</h2>
    <p>{{ 'terms.confidentiality.content' | translate }}</p>

    <h2>{{ 'terms.cancellation.title' | translate }}</h2>
    <p>{{ 'terms.cancellation.svet.title' | translate }}</p>
    <p>{{ 'terms.cancellation.svet.content' | translate }}</p>
    <p>{{ 'terms.cancellation.client.title' | translate }}</p>
    <p>{{ 'terms.cancellation.client.content' | translate }}</p>

    <h2>{{ 'terms.modification_of_terms.title' | translate }}</h2>
    <p>{{ 'terms.modification_of_terms.content' | translate }}</p>

    <h2>{{ 'terms.applicable_law_and_jurisdiction.title' | translate }}</h2>
    <p>{{ 'terms.applicable_law_and_jurisdiction.content' | translate }}</p>
</div>